// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css';
import axios from 'axios'
import VueAxios from 'vue-axios'
import VueResource from 'vue-resource';

import global from './components/global/common'


Vue.use(VueResource);

/******************拦截器(开始)******************/
Vue.http.interceptors.push((request, next)  =>{
  //登录成功后将后台返回的TOKEN在本地存下来,每次请求从localStorage中拿到存储的TOKEN值
  const user = JSON.parse(localStorage.getItem('access-admin'));
  // console.log(user);
  if(user){
    //如果请求时TOKEN存在,就为每次请求的headers中设置好TOKEN,后台根据headers中的TOKEN判断是否放行
    request.headers.set('TOKEN',user.token);
  }
  next((response) => {
    return response;
  });
});
/******************拦截器(结束)******************/

// window.addEventListener('visibilitychange', function () {
//   let user = JSON.parse(localStorage.getItem('access-admin'));
//   let newUsername = decodeURIComponent(window.atob(user.username))
//
//   if( global.username !== newUsername){
//     console.log("新:"+newUsername);
//     console.log("global:"+global.username)
//     window.location.reload();
//     global.username = newUsername;
//   }else {
//     global.username = newUsername;
//   }
// })

// Vue.use(VueAxios, axios)
Vue.use(router);
Vue.use(ElementUI);

Vue.config.productionTip = false
Vue.prototype.$axios = axios;


/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>',
  render: h => h(App),
  beforeCreate(){
    Vue.prototype.$bus = this // 安装全局事件总线
  }
})



// WEBPACK FOOTER //
// ./src/main.js